import axios from 'axios';
import store from '@/store';
import endpointVersion from '@/helpers/endpoint-version';
export const getDataIngestionData = ({ page = 1, limit = 10, home = 0 }) => {
    const brand = store.getters.selectedBrand;
    const tokenV3 = store.state.auth.tokenV3;
    return axios.get('/integration/getDataIngestionHistory', {
        baseURL: endpointVersion('v3'),
        params: {
            brand: brand.id,
            page,
            limit,
            home,
        },
        headers: { Authorization: `Bearer ${tokenV3}` },
    });
};
export const getExportDataIngestionHistory = ({ fileType, responseType, date }) => {
    const brand = store.getters.selectedBrand;
    const tokenV3 = store.state.auth.tokenV3;
    return axios.get('/integration/getDataIngestionHistory', {
        baseURL: endpointVersion('v3'),
        params: {
            brand: brand.id,
            export: fileType,
            date,
        },
        responseType,
        headers: { Authorization: `Bearer ${tokenV3}` },
    });
};
